module.exports = __webpack_public_path__ + "static/img/6.95060b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/6.png
// module id = xns+
// module chunks = 4